var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.725 13.874c.35 0 .628-.142.823-.418L14.257 2.36c.146-.216.212-.38.212-.552 0-.41-.302-.678-.75-.678-.319 0-.506.097-.702.38L5.692 12.18 1.89 7.63c-.204-.26-.4-.365-.702-.365-.456 0-.783.291-.783.701 0 .172.082.366.237.545l4.233 4.93c.253.29.498.432.849.432z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTick);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconTick.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };